<template>
  <section class="h_61">
    <m-img :src="controlList[activeIndex].bgImg"></m-img>
    <div class="video1" v-ia>
      <div class="alive_control">
        <div
          :key="index"
          v-for="(i, index) in controlList"
          class="control_item"
          :class="index === activeIndex && 'control_item_active'"
          @click="controlClick(index)"
        >
          {{ i.title }}
        </div>
      </div>
      <div class="video1_container">
        <m-video
          :key="index"
          v-for="(i, index) in controlList"
          :class="index === activeIndex && 'video_active'"
          :src="i.url"
          :poster="i.poster"
          disablepictureinpicture
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          autoplay
          class="border_container_night"
          muted
          :ref="`sliderVideo_${index}`"
        ></m-video>
      </div>
      <replay
        class="alive_replay"
        @click="() => replayVideo(this.$refs[`sliderVideo_${activeIndex}`][0])"
      />
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
      activeIndex: 0,
      controlList: [
        {
          title: '日常使用',
          bgImg: require('@/v2/mobile/assets/image/h_61_1.jpg'),
          url: require('@/v2/mobile/assets/video/61/0.mp4'),
          poster: require('@/v2/mobile/assets/video/61/0.webp'),
        },
        {
          title: '旅游出行',
          bgImg: require('@/v2/mobile/assets/image/h_61_2.jpg'),
          url: require('@/v2/mobile/assets/video/61/1.mp4'),
          poster: require('@/v2/mobile/assets/video/61/1.webp'),
        },
        {
          title: '保养车辆',
          bgImg: require('@/v2/mobile/assets/image/h_61_3.jpg'),
          url: require('@/v2/mobile/assets/video/61/2.mp4'),
          poster: require('@/v2/mobile/assets/video/61/2.webp'),
        },
        {
          title: '事故维修',
          bgImg: require('@/v2/mobile/assets/image/h_61_4.jpg'),
          url: require('@/v2/mobile/assets/video/61/3.mp4'),
          poster: require('@/v2/mobile/assets/video/61/3.webp'),
        },
      ],
      videoAbortController: new AbortController(),
    }
  },
  mounted() {
    this.$refs[`sliderVideo_${this.activeIndex}`][0] &&
      videoPlayByVisibleAreaH5(this.$refs[`sliderVideo_${this.activeIndex}`][0])
    this.controlClick(this.activeIndex)
    this.nextVideoPlay(this.activeIndex)
  },
  watch: {
    activeIndex(index) {
      this.nextVideoPlay(index)
    },
  },
  methods: {
    replayVideo,
    controlClick(index) {
      this.activeIndex = index
      this.controlList.forEach((item, idx) => {
        const video = this.$refs[`sliderVideo_${idx}`]?.[0]
        if (video) {
          if (this.activeIndex === idx) {
            video.play()
          } else {
            video.currentTime = 0
            video.pause()
          }
        }
      })
    },
    // 播放完成后自动跳转到下一个视频
    nextVideoPlay(index) {
      // 清除所有 ended 事件监听器
      this.videoAbortController.abort()
      this.videoAbortController = new AbortController()
      const video = this.$refs[`sliderVideo_${index}`]?.[0]
      const nextVideoPlay = () => {
        this.activeIndex = (index + 1) % this.controlList.length
        this.controlClick(this.activeIndex)
        video.removeEventListener('ended', nextVideoPlay)
      }
      video.addEventListener('ended', nextVideoPlay, {
        signal: this.videoAbortController.signal,
      })
    },
  },
}
</script>
<style lang="less" scoped>
.h_61 {
  position: relative;
  .video1 {
    position: absolute;
    width: 89%;
    top: 49%;
    left: 5%;
  }
  video {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  .video1_container {
    position: relative;
    display: flex;
    overflow: hidden;
    padding-top: 67%;
    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 98%;
      height: auto;
    }
    .video_active {
      z-index: 1;
    }
  }
  .alive_replay {
    margin-top: 0.1rem;
    margin-left: 3px;
    color: #3b82fc;
  }
  .alive_control {
    border-radius: 2rem;
    background-color: #f4f4f526;
    height: max-content;
    display: flex;
    margin-bottom: 0.3rem;
    width: 100%;
    .control_item {
      cursor: pointer;
      margin: 0.15rem;
      font-size: 0.25rem;
      border-radius: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: clamp(38px, 4.5vw, 44px);
      color: #ffffff99;
      text-align: center;
      flex: 1;
    }
    .control_item_active {
      color: black;
      font-weight: 600;
      background-color: white;
    }
  }
}
</style>
